/* @ngInject */
const myFloatingButton = () => {
  return {
    restrict: 'E',
    scope: {
      myStyle: '=?',
      myIcon: '=?',
      myLabel: '=?',
      myClick: '&?',
      enableLarge: '=',
      return: '=',
      myDisabled: '=',
    },
    template: require('./myFloatingButton.html'),

    /* @ngInject */
    controller: ($scope) => {

    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myFloatingButton



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/buttons/myFloatingButton.js